<template>
	<grid>
		<grid-group v-for="group in patientsGroups" :key="group.id" :title=" group.name">
			<template v-slot:options>
				<action-group>
					<action-group-item-button @click="editGroup_ClickHandler(group.id)" :title="$t('Edit group')" />
					<action-group-item-button @click="onDeleteGroup_ClickHandler(group.id)" :title="$t('Delete group')" :danger="true" />

				</action-group>
			</template>
			<grid-item v-for="patient in patientsByGroup(group)" :key="patient.id" :mainAction="true" @click="goToPacient_ClickHandler(patient)" :title="$t('Name')" :value="patient.name" :src="patient.picture" :avatar="true">
				<action-group>
					<action-group-item-link route="WatchDashboard" :args="{ watch_id: patient.id }" :title="$t('Go to')" />
					<action-group-item-button v-if="!havePin(patient)" @click="onPinPatient_ClickHandler(patient)" :title="$t('Pin pacient to dashboard')" />
					<action-group-item-button v-if="havePin(patient)" @click="onUnpinPatient_ClickHandler(patient)" :title="$t('Unpin pacient from dashboard')" />
					<action-group-item-link route="WatchProfile" :args="{ watch_id: patient.id }" :title="$t('Edit profile')" />
					<action-group-item-button @click="onDeletePatient_ClickHandler(patient.id)" :title="$t('Delete patient')" :danger="true" />
				</action-group>
			</grid-item>
			<grid-empty :showWhen="patientsByGroup(group).length === 0" :message="$t('There are no patients in this group yet.')" />
		</grid-group>
	</grid>
</template>

<script>
import Grid from '@/modules/ui/Grid'
import GridEmpty from '@/modules/ui/GridEmpty'
import GridItem from '@/modules/ui/GridItem'
import GridGroup from '@/modules/ui/GridGroup'
import ActionGroup from '@/modules/ui/ActionGroup'
import ActionGroupItemLink from '@/modules/ui/ActionGroupItemLink'
import ActionGroupItemButton from '@/modules/ui/ActionGroupItemButton'
import { mapGetters } from 'vuex'
import Avatar from '@/modules/ui/Avatar'
export default {
	props: [
		'user_uid'
	],
	components: {
		ActionGroup,
		ActionGroupItemLink,
		ActionGroupItemButton,
		Avatar,
		Grid,
		GridEmpty,
		GridItem,
		GridGroup
	},
	computed: {
		...mapGetters({
			havePin: 'GET_PIN_IS_PATIENT_IN_DASHBOARD',
			currentUser: 'CURRENT_USER',
			patientsByGroup: 'PATIENTS_BY_GROUP',
			patientsGroups: 'PATIENTS_GROUPS',
		})
	},
	methods: {
		onDeleteGroup_ClickHandler(group_id) {
			if (confirm('Delete?')) {
				this.$api.groups.patients.delete(this, this.user_uid, group_id)
					.then(response => {
						this.$appToast.show({
							type: 'success',
							title: 'Success',
							message: 'Group deleted.'
						})
					}).catch(error => {
						this.$appToast.show({
							type: 'error',
							title: 'Error',
							message: 'Issue deleting group.'
						})
					}).finally(() => {
						this.$store.dispatch('GET_PATIENTS', this)
					})
			}
		},
		editGroup_ClickHandler(group_id) {
			this.$root.$emit('editGroup', group_id)
		},
		onDeletePatient_ClickHandler(patient_id) {
			if (confirm(this.$t('buttons.general.delete') + '?')) {
				alert('Brevemente')
				this.$appToast.show({
					type: 'success',
					title: 'Success',
					message: this.$t('Patient deleted.')
				})
				// this.$api.watch.delete(this, this.user_uid, device_id)
				// 	.then(response => {
				// 		this.$appToast.show({
				// 			type: 'success',
				// 			title: 'Success',
				// 			message: 'Device deleted.'
				// 		})
				// 	}).catch(error => {
				// 		this.$appToast.show({
				// 			type: 'error',
				// 			title: 'Error',
				// 			message: 'Issue deleting device.'
				// 		})
				// 	}).finally(() => {
				// 		this.$store.dispatch('GET_PATIENTS', this)
				// 	})
			}
		},
		goToPacient_ClickHandler(patient) {
			this.$router.push({
				name: 'WatchDashboard',
				params: {
					user_uid: this.currentUser.uid,
					watch_id: patient.id
				}
			})
		},
		onPinPatient_ClickHandler(patient) {
			this.$store.dispatch('POST_PIN_PATIENT_DASHBOARD', { refThis: this, item: patient })
		},
		onUnpinPatient_ClickHandler(patient) {
			this.$store.dispatch('DELETE_PIN_PATIENT_DASHBOARD', { refThis: this, item: patient })
		}
	},
	created() {
		this.$store.dispatch('GET_PATIENTS', this)
	}
}
</script>

<style scope>
.grid {}
.group {}
.group-title {
	color: #333;
	border-bottom: 1px solid #f0f0f0;
	font-size: 16px;
	font-weight: 700;
	margin: 20px 0 2rem 0;
	padding: 0 0 0.7rem 0;
	position: relative;
	font-weight: 900;
	letter-spacing: .05rem;
}
.group-title:after {
	content: ' ';
	display: block;
	height: 4px;
	width: 25px;
	background-color: var(--main-color);
	position: absolute;
	bottom: -4px;
}
.row {
	border-radius: 3px;
	background-color: #fff;
	box-shadow: rgba(0,0,0,0.3) 0 0 5px;
	margin: 10px 0;
	display: flex;
}
.block {
	padding: 10px 20px;
	display: flex;
	flex-direction: column;
	justify-content: center;
}
.block-small {
	padding: 0 0 0 20px;
	align-items: center;
	justify-content: center;
}
.block-grow {
	flex: 1;
}
.title {
	color: #aaa;
	font-size: 12px;
	min-height: 14px;
}
.b-picture {
	width: 35px;
	height: 35px;
	background-color: var(--main-color);
	border-radius: 100%;
	box-shadow: rgba(0,0,0,0.1) 0 0 5px;
}
.value {
	min-height: 20px;
}
.value.v-center {
	text-align: center;
}
.action {
	border-radius: 3px;
	background-color: var(--main-color);
	height: 30px;
	min-width: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 10px;
	font-size: 12px;
	text-decoration: none;
	color: var(--main-color-soft);
	box-shadow: rgba(0,0,0,0.1) 0 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/watches/UserWatchesPatientsList.vue